import {
  SET_FORM_DATA,
} from "../types";

export const formStates = {
  studentRegistration: {
    // email: "aaron@gmail.com",
    // email: "",
    // name: "Student Liew",
    // nric: "900918-07-5617",
    // dob: "18/09/1990",
    // programLvl: 1,
    // phoneNo: "173293688",
    // gender: "M"
    uuid: null,
    branch: null,
    email: null,
    name: null,
    nric: null,
    programLvl: null,
    phoneNo: null,
    gender: null,
    emergencyContactName: null,
    emergencyContactPhoneNo: null,
    emergencyContactRelationship: null,
    schedule: null
  },

  courseRegistration: {
    subjectName: null,
    programLvl: null,
  },

  teacherRegistration: {
    // name: "Liew Yee Foo",
    // phoneNo: "173293688",
    // gender: "M",
    // identification: "900918-07-5617",
    // dob: "18/09/1990",
    // paymentType: 1,
    // splitRatio: "4/6",
    // hourRate: null,
    // tuitionCourse: [],

    name: null,
    phoneNo: null,
    gender: null,
    idNo: null,
    bankName: null,
    bankAccountNo: null,
    paymentType: null,
    paymentRate: 0,
    tuitionCourse: [],
  }
};

export const formReducer = (state, action) => {
  switch (action.type) {
    case SET_FORM_DATA:
      return {
        ...state,
        ...action.data
      };
    default: return state
  }
};